import styled from '@emotion/styled';
import { colorPalette } from 'styles/partials/colors';

export const Th = styled.th({
  padding: 0,
});

export const Td = styled.td({
  border: '1px solid #265183',
  color: '#333333',
  fontSize: '16px',
  fontWeight: 400,
  padding: 0,

  ':hover': {
    backgroundColor: colorPalette.tableBlueCell,
    cursor: 'pointer',
  },
});

export const StyledTable = styled.table({
  borderSpacing: 0,
  width: '100%',
});
